'use client';
import { fetchErrors } from '@susu/custom-made/app/configurator/fetchErrors';
import Modal from '../modal/modal';
import { ButtonType } from '../button/button';
import { useEffect } from 'react';
import { DataDogConfig, initializeDataDog } from '@susu/custom-made/utils/monitoring/dataDog';
import { typeErrorData, typeEnvironments } from '@susu/custom-made/utils/interfaces';
import { getCMDatadogLogger } from '@susu/custom-made/utils/utils';

export default function Error({
  customError,
  errorData,
  datadogClientToken,
  datadogApplicationId
}: Readonly<{
  customError: string;
  errorData: typeErrorData;
  datadogClientToken: string;
  datadogApplicationId: string;
}>) {

  useEffect(() => {
    const dataDogConfiguration: DataDogConfig = {
      applicationId: datadogApplicationId,
      clientToken: datadogClientToken,
      env: (process.env.NEXT_PUBLIC_CM_env as typeEnvironments) ?? 'dev',
    };
    initializeDataDog(dataDogConfiguration);

    if (customError && errorData) {
      getCMDatadogLogger()?.error('Custom made Server Error - ' + customError, errorData);
    }
  }, [errorData, customError]);

  return (
    <div>
      <Modal
        isOpen={true}
        title={fetchErrors[customError].title}
        description={fetchErrors[customError].description}
        firstButtonText={fetchErrors[customError].buttonText}
        firstButtonType={ButtonType.Primary}
        onFirstButtonClick={() => {
          fetchErrors[customError].handler();
        }}
        isFullSize={true}
        testId="error-modal"
      />
    </div>
  );
}